import { Position } from '@capacitor/geolocation';

export class Place implements Position {
  coords: {
    latitude: number;
    longitude: number;
    accuracy: number;
    altitudeAccuracy: number;
    altitude: number;
    speed: number;
    heading: number;
  };
  timestamp: number;
  name: string;
  insideX: integer;
  insideY: integer;
  imageName: string;
  prerequisites?: Array<string>;
  borderless?: boolean;
  requiresHealth?: boolean = false;
  musicTrack?: string;
}

export const PlacesList: Place[] = [
  // 37.545430, -77.449430
  {
    name: 'Brandt Hall',
    coords: {
      latitude: 37.548231583594315,
      longitude: -77.45027432137994,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'brandtHall',
  },
  {
    name: 'Monroe Park',
    coords: {
      latitude: 37.546791837721045,
      longitude: -77.45031487753253,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'fountain',
  },
  {
    name: 'VCU Engineering Building',
    coords: {
      latitude: 37.545430,
      longitude: -77.449430,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'vcuLab',
  },
  {
    name: 'Rest in Pieces',
    coords: {
      latitude: 37.54060389869084,
      longitude: -77.45152426389899,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'restInPieces',
  },
  {
    name: 'Hollywood Cemetery',
    coords: {
      latitude: 37.5404,
      longitude: -77.4530,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'monroeTomb',
  },
  {
    name: 'Richmond Vampire',
    coords: {
      latitude: 37.53760814407815,
      longitude: -77.4541968346206,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'mausoleum',
    requiresHealth: true,
    prerequisites: ["Church Hill"]
  },
  {
    name: "James Monroe's Grave",
    coords: {
      latitude: 37.5337758,
      longitude: -77.4565111,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'monroeTomb',
    requiresHealth: true,
  },
  {
    name: 'Pump House',
    coords: {
      latitude: 37.53662592067073,
      longitude: -77.48595408665581,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'pumpHouse',
    prerequisites: ["James Monroe's Grave"],
    requiresHealth: true,
  },
  {
    name: "Pratt's Castle",
    coords: {
      latitude: 37.5379,// 37.3213,
      longitude: -77.4443,// -77.2643,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'prattsCastle',
    prerequisites: ["Belle Isle Power Plant"],
    requiresHealth: true
  },
  {
    name: "Foushee's Mill",
    coords: {
      latitude: 37.5315,
      longitude: -77.4772,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'fousheesMill',
  },
  {
    name: 'Church Hill',
    coords: {
      latitude: 37.5362,
      longitude: -77.4232,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'churchHillTunnel',
    prerequisites: ["Poe Museum"],
    requiresHealth: true,
  },
  {
    name: 'Poe Museum',
    coords: {
      latitude: 37.5321,
      longitude: -77.426,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'oldStoneHouse',
    requiresHealth: true,
    prerequisites: ["Monumental Church"],
  },
  {
    name: 'Belle Isle Gym',
    coords: {
      latitude: 37.530534,
      longitude: -77.449679,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'bellIsleGym',
    prerequisites: [],
    borderless: true,
  },
  {
    name: 'Belle Isle Power Plant',
    coords: {
      
      latitude: 37.527395359761,
      longitude: -77.45403909858766,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'powerPlant',
    prerequisites: ["Pump House"],
  },
  {
    name: 'Browns Island',
    coords: {
      latitude: 37.5339,
      longitude: -77.441,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'monroeTomb',
  },
  {
    name: 'Japanese Garden',
    coords: {
      latitude: 37.532644,
      longitude: -77.476527,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'japaneseHouse',
    musicTrack: 'Oriole',
  },
  {
    name: 'Monumental Church',
    coords: {
      latitude: 37.53886,
      longitude: -77.43005,
      accuracy: 0,
      altitude: 0,
      altitudeAccuracy: 0,
      speed: 0,
      heading: 0,
    },
    timestamp: 0,
    insideX: 0,
    insideY: 0,
    imageName: 'theatreExterior',
    prerequisites: ["Pratt's Castle"],
    requiresHealth: true,
  },
];
